import { render } from "./MapSection.vue?vue&type=template&id=970f0cfc&scoped=true"
import script from "./MapSection.vue?vue&type=script&lang=js"
export * from "./MapSection.vue?vue&type=script&lang=js"

import "./MapSection.vue?vue&type=style&index=0&id=970f0cfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-970f0cfc"]])

export default __exports__